<template>
    <v-card class="ma-4">
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          @on-add-click="add"
          :exportFileName="title"
          :allowGrouping="false"
          :allowFilterPanel="false"
          :title="title"
        >
          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </a>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="deleteItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </a>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
          </template>
          <template slot="columnTemplates" slot-scope="row">
            <div v-if="row.data.field == 'Type'">
              <span>{{ getType(row.data.item) }}</span>
            </div>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
</template>

<script>
import DocumentLifecycleService from '@/services/DocumentLifecycleService';
import Utils from '@/ecm/common/Utils';

export default {
    components: {
    },
    data() {
        return {
            title: this.$t('DocumentLifecycle'),
            grid: {
                key: 'documentLifecycle',
                dataSource: DocumentLifecycleService.getGrid(),
                columns: [
                    {
                        field: 'Description',
                        caption: this.$t('Description'),
                        type: 'string',
                    },
                    {
                        field: 'ContentTypeName',
                        caption: this.$t('ContentType'),
                        type: 'string',
                    },
                    {
                        field: 'DefFieldName',
                        caption: this.$t('Field'),
                        type: 'string',
                    },
                    {
                        field: 'PreservationMonths',
                        caption: `${this.$t('PreservationTime')} (${this.$t('Months')})`,
                        type: 'string',
                    },
                    {
                        field: 'Type',
                        caption: this.$t('Type'),
                        type: 'string',
                        hasTemplate: true,
                    },
                ],
            },
            modalKey: 'modaldocumentLifecycle',
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modalKey];
        },
        gridInstance() {
            return this.$refs[this.grid.key];
        },
    },
    methods: {
        getType(item) {
            switch (item.Type) {
            case 1:
                return this.$t('Archive');
            case 2:
                return this.$t('Site.DocumentManagement.Destroy');
            }
        },
        deleteItem(dto) {
            this.$confirm(this.$t('ItemDeleteConfirmation'), {
                title: this.$t('Delete'),
                icon: 'mdi-alert',
                color: 'red',
                buttonTrueText: this.$t('Delete'),
                buttonFalseText: this.$t('Cancel'),
            }).then((res) => {
                if (res == 1) {
                    DocumentLifecycleService.delete(dto.Id).then((result) => {
                        if (result) {
                            this.gridInstance.refresh();
                            Utils.toast.success(this.$t('DocumentLifecycle') + ' ' + this.$t('DeletedSuccessfully'));
                        }
                    });
                }
            });
        },
        add() {
            this.$router.push('/administration/document-lifecycle/0');
        },
        editItem(dto) {
            this.$router.push(`/administration/document-lifecycle/${dto.Id}`);
        },
    },
};

</script>
